var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Performance/star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99979 0.667148C8.25332 0.667148 8.48487 0.811075 8.59709 1.03842L10.5023 4.89808L14.7628 5.52082C15.0136 5.55748 15.2219 5.73334 15.3001 5.97447C15.3783 6.21561 15.3128 6.48022 15.1312 6.65709L12.0489 9.6593L12.7763 13.9007C12.8192 14.1506 12.7164 14.4031 12.5113 14.5522C12.3061 14.7012 12.0342 14.7208 11.8097 14.6028L7.99979 12.5992L4.18983 14.6028C3.9654 14.7208 3.69344 14.7012 3.48829 14.5522C3.28315 14.4031 3.1804 14.1506 3.22326 13.9007L3.95071 9.6593L0.868354 6.65709C0.686761 6.48022 0.621301 6.21561 0.699487 5.97447C0.777673 5.73334 0.985952 5.55748 1.23678 5.52082L5.49732 4.89808L7.40248 1.03842C7.5147 0.811075 7.74625 0.667148 7.99979 0.667148ZM7.99979 2.83816L6.53709 5.80142C6.44014 5.99782 6.25284 6.13402 6.03612 6.16569L2.76419 6.64393L5.13122 8.94942C5.28833 9.10245 5.36005 9.32302 5.32297 9.53919L4.7645 12.7954L7.68974 11.257C7.88384 11.155 8.11573 11.155 8.30983 11.257L11.2351 12.7954L10.6766 9.53919C10.6395 9.32302 10.7112 9.10245 10.8684 8.94942L13.2354 6.64393L9.96345 6.16569C9.74673 6.13402 9.55943 5.99782 9.46248 5.80142L7.99979 2.83816Z",
    fill: "#DB2763"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f5ef0ba3b3123b04fd53717b90c5b178.svg";
export { ForwardRef as ReactComponent };